<mat-form-field appearance="outline" floatLabel="always">
  <mat-label>{{ label() }}</mat-label>
  <mat-select #matSelect="matSelect" [id]="selectId()" multiple
    [ngModel]="value()" (ngModelChange)="onValueChange($event)" [disabled]="disabled()"
    [placeholder]="placeholder()">
    <mat-select-trigger>
      <div class="chip-row" #chipRow>
        @if (selectedNames().length === 0) {
          <span class="select-placeholder">{{ placeholder() }}</span>
        } 
        @else {
          @for (name of visibleNames(); track name) {
            <span class="chip">{{ name }}</span>
          }
          @if (hiddenCount() > 0) {
            <span class="chip chip--more"
              (click)="$event.stopPropagation(); openSelect()"
              [matTooltip]="moreTooltip()"
              matTooltipPosition="above">
              +{{ hiddenCount() }} more
            </span>
          }
        }
      </div>
    </mat-select-trigger>

    <mat-option value="select-all" selectAll [allValues]="allOptionIds()">
        select all
    </mat-option>
    @for (opt of options(); track opt.id) {
      <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
    }
  </mat-select>

  @if (value().length > 0) {
    <button matSuffix type="button" class="clear-btn" 
        [attr.aria-label]="'Clear ' + label()"
        (click)="$event.stopPropagation(); clearValue()">
      <i class="icon icon-remove"></i>
    </button>
  }
</mat-form-field>

<!-- Hidden container for measuring chip widths -->
<div class="measure-container" #measureContainer aria-hidden="true">
  @for (name of selectedNames(); track name) {
    <span class="chip chip--measure">{{ name }}</span>
  }
</div>
